import { IBuildersProjectsData } from '../../types/buildersProjects';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EBuildersProjectsActionType, TAppendBuildersProjectsData } from './types';

export const appendBuildersProjectsData: (data: IBuildersProjectsData) => TAppendBuildersProjectsData = actionGenerator<
  EBuildersProjectsActionType.AppendData,
  IBuildersProjectsData
>(EBuildersProjectsActionType.AppendData);
